module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAANCAMAAAB4p3UoAAAASFBMVEWIjp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp+Ijp/vV7zOAAAAF3RSTlPyygEY9EZXNJ6II9VtBvuSDrqvgkCWwcq1qakAAABVSURBVHjalchHDoAwAMTAhXRCb/7/T5EQUQQ3fPNo2EClkWNQ3j21PpwCZ5rncxdGJEhtuiG2PUgCGuMAPy8UAddNIVioQvQJipT+iP2IFd8U9W69AFw0DilxFEYUAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/ic_email.png
// module id = MdEg
// module chunks = 9